// Code review - Completed
// Documentation - Completed
import React, { useState } from "react";
import { mainTable } from "../css/Common";
import MainPopup from "../popup-containers/MainPopup";
const ReportTableGrid = ({
  tableHeight,
  headerData,
  tableData,
  onViewGrid,
  currentPage,
  itemsPerPage,
  viewBag,
  onSelectedGrid,
  checkBoxStatus,
  selectedRows,
  clearCheckBoxStatus,
}) => {
  let currentData = [];
  const [startIndex, setStartIndex] = useState(0);

  // if (Array.isArray(tableData)) {

  //   const startIndex = (currentPage - 1) * itemsPerPage;
  //   const endIndex = startIndex + itemsPerPage;
  //   currentData = tableData.slice(startIndex, endIndex);
  // }

  if (currentPage) {
    if (Array.isArray(tableData)) {
      if (itemsPerPage === -1) {
        currentData = tableData; // No slicing, show all data
      } else {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        currentData = tableData.slice(startIndex, endIndex); // Pagination logic
      }
    }
  } else {
    currentData = [tableData];
  }
  const [viewsAll, setViewsAll] = useState(false);
  const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false);
  const [viewImage, setViewImage] = useState({ popup: false, url: "" });
  // const [selectedRows, setSelectedRows] = useState([]);
  const [showCheckBox, setshowCheckBox] = useState(true);
  const [currentRowIndex, setCurrentRowIndex] = useState(null);
  const showPopUp = (views, rowIndex) => {
    setViewsAll(views);
    setCurrentRowIndex(views ? rowIndex : null);
  };
  const handleHeaderCheckboxChange = () => {
    const allIndexes = tableData.map((_, idx) => idx);
    const isAllSelected = selectedRows.length === tableData.length;

    const newSelection = isAllSelected ? [] : allIndexes;
    checkBoxStatus(newSelection); // update parent
    setIsHeaderCheckboxChecked(newSelection.length === tableData.length);
  };

  const handleRowCheckboxChange = (rowIndex) => {
    let updatedSelectedRows;

    if (selectedRows.includes(rowIndex)) {
      // Remove
      updatedSelectedRows = selectedRows.filter((idx) => idx !== rowIndex);
    } else {
      // Add
      updatedSelectedRows = [...selectedRows, rowIndex];
    }

    checkBoxStatus(updatedSelectedRows); // send update to parent

    // If all rows are checked, header checkbox checked = true, else false
    setIsHeaderCheckboxChecked(updatedSelectedRows.length === tableData.length);

    if (typeof onSelectedGrid === "function") {
      const selectedRowData = updatedSelectedRows.map((i) => tableData[i]);
      onSelectedGrid(selectedRowData);
    }
  };

  return (
    <div className={`${mainTable.tableShadowWidth}`}>
      <div className={mainTable.table} role="table">
        <div className={mainTable.tableHeader} role="rowgroup">
          {showCheckBox && (
            <div className="px-2 py-2 md:py-3 flex bg-[#1f2937]">
              <input
                type="checkbox"
                checked={
                  selectedRows.length === tableData.length &&
                  tableData.length > 0
                }
                onChange={handleHeaderCheckboxChange}
              />
            </div>
          )}

          {headerData.map((item, itemIndex) => (
            <div key={itemIndex} className={item.width} role="columnheader">
              <label className="text-sm font-medium">{item.title}</label>
            </div>
          ))}
        </div>

        <div
          className={`overflow-y-auto ${tableHeight ? tableHeight : "h-96"} `}
        >
          {currentData.length > 0 ?
            currentData.map((data, rowIndex) => (
              <div class={mainTable.tableRow}>
                <div className="px-2 py-2  md:py-3 flex bg-white">
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(data.oldIndex,)}
                    onChange={() => handleRowCheckboxChange(data.oldIndex)}
                  />
                </div>
                {headerData.map((keyData) => (
                  <div scope="cell" role="cell" className={keyData.width}>
                    {keyData.key === "action" ? (
                      <div>
                        <button
                          id="dropdownMenuIconButton"
                          data-dropdown-toggle="dropdownDots"
                          class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none "
                          type="button"
                          onClick={() => showPopUp(!viewsAll, rowIndex)}
                        >
                          <svg
                            class="w-6 h-6"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                          </svg>
                        </button>
                        {viewsAll && currentRowIndex == rowIndex && (
                          <div
                            id="dropdownDots"
                            class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44 "
                          >
                            <ul
                              class=""
                              aria-labelledby="dropdownMenuIconButton"
                            >
                              {viewBag == 1 && (
                                <li>
                                  <a
                                    onClick={() => {
                                      onViewGrid(
                                        data.oldIndex,
                                        1
                                      );
                                      showPopUp(false);
                                    }}
                                    class="block px-4 py-2 hover:bg-gray-100 "
                                  >
                                    View
                                  </a>
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    ) : keyData.title === "S.No." ? (
                      <div>
                        {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                      </div>
                    ) : keyData.title === "S.No." && data.InActivatedBy ? (
                      <div class={keyData.width1}>
                        {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                      </div>
                    ) : keyData.key === "RowNumber" ? (
                      <div title={data[keyData.key]}>
                        {data[keyData.key] != "" ? data[keyData.key] : ""}
                      </div>
                    ) : keyData.key === "Attachment" ? (
                      <div className="flex flex-col gap-2">
                        <button
                          id="dropdownMenuIconButton"
                          data-dropdown-toggle="dropdownDots"
                          type="button"
                          className="w-full h-9 bg-gray-800 text-white hover:text-gray-800 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-[#24292F]/50 font-medium rounded-lg text-sm px-5 py-2.5 flex items-center justify-center"
                          onClick={() => onViewGrid(rowIndex)}
                        >
                          View
                        </button>
                      </div>
                    ) : (
                      <div class="relative">
                        <div
                          class="truncate relative"
                          title={data[keyData.key]}
                        >
                          {data[keyData.key]}
                        </div>
                        <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"></div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )) : (
              <div class="text-center text-red-500 mt-4">No record found</div>
            )
            }
        </div>
      </div>

      <div className={mainTable.tableMobile} role="table">
        <div className="w-full md:overflow-y-auto lg:h-96 h-full">
          {showCheckBox && (
            <div className="px-2 py-2 md:py-3 flex bg-[#1f2937]">
              <input
                type="checkbox"
                checked={isHeaderCheckboxChecked}
                onChange={handleHeaderCheckboxChange}
              />
            </div>
          )}
          {currentData.length > 0 &&
            currentData.map((data, rowIndex) => (
              <div scope="col" class={mainTable.mobileTable}>
                {headerData.map((keyData) => (
                  <div scope="cell" class={mainTable.tableData} role="cell">
                    {keyData.key === "action" || keyData.key === "action1" ? (
                      <div class={mainTable.tableData}>
                        <div className="md:block hidden">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none "
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="md:hidden block flex justify-center">
                          {viewBag === 1 && (
                            <button
                              className="bg-[#213F99] text-white mr-1 p-1 rounded-lg"
                              onClick={() =>
                                onViewGrid(
                                  data.oldIndex,
                                  1
                                )
                              }
                            >
                              View
                            </button>
                          )}
                        </div>
                      </div>
                    ) : keyData.key === "Attachment" ? (
                      <div className="flex flex-col gap-2">
                        <button
                          id="dropdownMenuIconButton"
                          data-dropdown-toggle="dropdownDots"
                          type="button"
                          className="w-full h-9 bg-gray-800 text-white hover:text-gray-800 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-[#24292F]/50 font-medium rounded-lg text-sm px-5 py-2.5 flex items-center justify-center"
                          onClick={() => onViewGrid(rowIndex)}
                        >
                          View
                        </button>
                      </div>
                    ) : keyData.title === "S.No." ? (
                      <div className="flex border p-1">
                        <div className="flex basis-1/2">
                          <input
                            type="checkbox"
                            className="border-4 border-[#1f2a44]"
                            checked={
                              isHeaderCheckboxChecked ||
                              (selectedRows?.includes(rowIndex) ?? false)
                            }
                            onChange={() => handleRowCheckboxChange(rowIndex)}
                          />
                        </div>
                        <div className="flex justify-center">
                           {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                        </div>
                      </div>
                    ) : (
                      <div className="grid max-md:grid-cols-2 border p-1">
                        <div className="font-bold whitespace-pre-wrap break-words">
                          {keyData.title}
                        </div>
                        <div className="whitespace-pre-wrap break-words">
                          {data[keyData.key]}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
      <MainPopup
        popUpOpen={viewImage.popup}
        setpopUpOpen={() => setViewImage({ popup: false, url: "" })}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={() => setViewImage({ popup: false, url: "" })}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <div className="flex justify-center p-12 items-center">
            <img src={viewImage.url} class={"w-96 h-96"} />
          </div>
        </div>
      </MainPopup>
    </div>
  );
};

export default ReportTableGrid;
